import type { IconData } from '@stacksjs/iconify-core'

export const chevronCircleDownRightF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M11 11H6a1 1 0 0 0 0 2h6a1 1 0 0 0 1-1V6a1 1 0 0 0-2 0zm-1 9C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronCircleDownRightF
